import React from "react";

function AboutUs() {
  return (
    <div className="helper-container">
      <h1 className="heading-body heading-section">About us</h1>
      <div className="about-us-intro">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus in
          ipsum posuere, malesuada nulla eget, consectetur metus. Aliquam
          vulputate sem sed velit ultrices, ac ullamcorper augue viverra.
        </p>
        <p>
          Nam finibus dictum leo at vehicula. Aliquam et congue diam, eu euismod
          turpis. Nunc orci turpis, malesuada ac ullamcorper non, hendrerit
          rhoncus libero. Etiam eget diam dapibus, lacinia nulla id, semper
          justo. Sed feugiat tellus eu dui condimentum aliquam. Etiam id
          elementum tortor. Suspendisse at erat ut augue commodo rutrum.
          Pellentesque felis tortor, scelerisque sed elementum vitae, aliquam
          blandit est. Maecenas in nisi ut nibh vulputate efficitur et ut odio.
          <a href="">Maecenas vitae faucibus</a> erat.Pellentesque consectetur
          massa risus, ac venenatis elit.
        </p>
        <p>
          Pellentesque augue ipsum, mollis sit amet hendrerit sit amet,
          tincidunt ultrices odio. Sed suscipit orci vel metus convallis, ut
          sodales tortor tempus. Nullam tristique ligula neque, rutrum vehicula
          erat ornare a. Nunc vel rutrum est. Donec velit enim, suscipit vitae
          rutrum ac, sollicitudin et nisi. Vivamus lectus justo, consectetur sed
          metus eu, auctor finibus lorem. Cras eu nulla sit amet dui fringilla
          consequat sagittis ac nibh. Cras tincidunt vestibulum hendrerit. Duis
          ultrices interdum nulla, non consequat enim semper et. Nulla
          efficitur, ex eu convallis dignissim, lectus diam scelerisque leo,
          vitae vulputate diam magna sit amet metus. Nulla iaculis et mi eu
          faucibus. Nullam lectus enim, hendrerit in est sit amet, iaculis
          vestibulum nibh.
        </p>
      </div>
      <div className="image-container-about">
        <img src="./resources/shutterstock_696636415.jpg" alt="office space" />
      </div>
      <p>
        Nam finibus dictum leo at vehicula. Aliquam et congue diam, eu euismod
        turpis. Nunc orci turpis, malesuada ac ullamcorper non, hendrerit
        rhoncus libero. Etiam eget diam dapibus, lacinia nulla id, semper justo.
        Sed feugiat tellus eu dui condimentum aliquam. Etiam id elementum
        tortor. Suspendisse at erat ut augue commodo rutrum. Pellentesque felis
        tortor, scelerisque sed elementum vitae, aliquam blandit est.
      </p>
      <h1 className="heading-list">Taria duo ut vis semper abhorreant:</h1>
      <ul>
        <li>
          <p>Cats can jump up to six times their length.</p>
        </li>
        <li>
          <p>
            Cats are nearsighted, but their peripheral vision and night vision
            are much better than that of humans.
          </p>
        </li>
        <li>
          <p>Cats have 230 bones, while humans only have 206.</p>
        </li>
        <li>
          <p>
            Cats have the largest eyes relative to their head size of any
            mammal.
          </p>
        </li>
      </ul>
      <p>
        Etiam eget diam dapibus, lacinia nulla id, semper justo. Sed feugiat
        tellus eu dui condimentum aliquam. Etiam id elementum tortor.
        Suspendisse at erat ut augue commodo rutrum. Pellentesque felis tortor,
        scelerisque sed elementum vitae, aliquam blandit est.
      </p>
      <p>
        Nullam tristique ligula neque, rutrum vehicula erat ornare a. Nunc vel
        rutrum est. Donec velit enim, suscipit vitae rutrum ac, sollicitudin et
        nisi. Vivamus lectus justo, consectetur sed metus eu, auctor finibus
        lorem. Cras eu nulla sit amet dui fringilla consequat sagittis ac nibh.
        Cras tincidunt vestibulum hendrerit. Duis ultrices interdum nulla, non
        consequat enim semper et. Nulla efficitur, ex eu convallis dignissim,
        lectus diam scelerisque leo, vitae vulputate diam magna sit amet metus.
        Nulla iaculis et mi eu faucibus. Nullam lectus enim, hendrerit in est
        sit amet, iaculis vestibulum nibh.
      </p>
    </div>
  );
}

export default AboutUs;
